import styled from 'styled-components'
import { Body } from '../../../typography'

const margin = 'margin: 12px 0;'

export const SubjectGroupWrapper = styled.div`
  ${margin}
`

export const PracticeTestHelper = styled(Body)`
  ${margin}
`

export const PracticeWrapper = styled.div`
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
`
